import React from 'react'

const Navbar = () => {
    return (
        <div className='navbar'>
            <span>Face Detector</span>
        </div>
    )
}

export default Navbar
